export type Platform = 'ios' | 'android' | 'desktop';

/**
 * Detects the user's platform based on user agent
 */
export function detectPlatform(): Platform {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  return 'desktop';
}

/**
 * Returns the appropriate redirect URL based on platform
 */
export function getRedirectUrl(
  iosUrl: string | undefined,
  androidUrl: string | undefined,
  fallbackUrl: string | undefined
): string | null {
  const platform = detectPlatform();

  switch (platform) {
    case 'ios':
      return iosUrl || fallbackUrl || null;
    case 'android':
      return androidUrl || fallbackUrl || null;
    default:
      return fallbackUrl || null;
  }
}
